import { dataChevronDoubleRight } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronDoubleRight = /*#__PURE__*/createIcon(dataChevronDoubleRight)
export default IconChevronDoubleRight
